module.exports = __webpack_public_path__ + "static/media/NINE.31f8ffc7.png";